import React from 'react';
import { ItemWithTranslation, SportsFavoritesMenuManifestazioneDto, SportsSottoVoceMenu } from 'types/swagger';
import { isNotEmpty, isTruthy, toSportUrlCase } from 'utility/functions';
import { templateManifestazioneLoadingUpdated } from 'features/sport/sportSlice';

import { Content as Accordion } from '@radix-ui/react-accordion';
import { AnchorLink } from 'components/anchorLink';
import { DynamicImage, enLoading } from 'components/Image';
import styles from './SportNavAccordionContent.module.scss';
import { useAppDispatch } from 'lib/centralStore';
import { useTranslation } from 'hooks/useLingUI';
import classNames from 'classnames';
import { useInternalSession } from 'hooks';
import { AuthenticatedPin } from 'features/sport/components/sportNav/sportNavAccordion/components/authenticatedPin/AuthenticatedPin';

export type SportNavAccordionContentProps = {
  manifestazioni: Array<SportsFavoritesMenuManifestazioneDto | SportsSottoVoceMenu>;
};

export type AddManifestazioneToPreferitiPayload = {
  id: string;
  slug?: string;
  descrizione?: string;
};

// eslint-disable-next-line react/display-name
export const SportNavAccordionContent = React.forwardRef<HTMLDivElement, SportNavAccordionContentProps>(
  ({ ...props }, forwardedRef) => {
    const { t } = useTranslation();
    const { manifestazioni } = props;

    const dispatch = useAppDispatch();
    const { isAuthenticated } = useInternalSession();

    return (
      <Accordion ref={forwardedRef} className={styles.container}>
        <ul className={styles.list}>
          {isTruthy(manifestazioni?.length) &&
            manifestazioni.map((item, index) => {
              const { id, slug, isSubLevel } = item ?? {};
              const { descrizione, descrizioneTrKey } = (item ?? {}) as ItemWithTranslation<{ descrizione?: string }>;
              const idString = String(id);
              return (
                <li
                  className={classNames(styles.listItem, { [styles.listSubItem]: isSubLevel })}
                  key={`${id}_${index}`}
                  suppressHydrationWarning
                >
                  <AnchorLink
                    className={styles.link}
                    href={toSportUrlCase(`/${slug}`)}
                    onClick={() => {
                      dispatch(templateManifestazioneLoadingUpdated());
                      // dispatch(toggleNavMobile(false));
                    }}
                  >
                    {isNotEmpty(item.iconSrc) && (
                      <DynamicImage
                        src={item.iconSrc}
                        alt={item.descrizione ?? ''}
                        width={16}
                        height={16}
                        loading={enLoading.lazy}
                        decoding="async"
                        className={styles.iconCountry}
                      />
                    )}
                    {t(descrizioneTrKey, descrizione)}
                  </AnchorLink>
                  {isAuthenticated && <AuthenticatedPin id={idString} slug={slug ?? ''} descrizione={descrizione} />}
                </li>
              );
            })}
        </ul>
      </Accordion>
    );
  }
);